import { Component, Input } from '@angular/core';

/** Visual stepper for multi-step service flows. Purely presentational —
 *  the host screen keeps owning the actual step logic. */
@Component({
  selector: 'er-stepper',
  template: `
    <div class="er-stepper" role="list">
      <div class="er-step" role="listitem"
           *ngFor="let s of steps; let i = index"
           [class.is-done]="i < active"
           [class.is-active]="i === active">
        <span class="er-step__dot">
          <ng-container *ngIf="i < active">✓</ng-container>
          <ng-container *ngIf="i >= active">{{ i + 1 }}</ng-container>
        </span>
        <span>{{ s }}</span>
      </div>
    </div>`
})
export class ErStepperComponent {
  @Input() steps: string[] = [];
  @Input() active = 0;
}
